const BASE62 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";


export const idToSlug = (_id) => {
    const hex = _id.replace(/-/g, '');
    if (hex.length !== 24) throw new Error('Invalid _id length');

    // Split into three 8-character parts
    const parts = [
        parseInt(hex.substring(0, 8), 16),
        parseInt(hex.substring(8, 16), 16),
        parseInt(hex.substring(16), 16)
    ];

    return parts.map(num => {
        let slug = '';
        do {
            slug = BASE62[num % 62] + slug;
            num = Math.floor(num / 62);
        } while (num > 0);
        return slug;
    }).join('-');
};

// Handles both old and new slug formats
export const slugToId = (slug) => {
    // Try three-part format first (new version)
    if (slug.includes('-')) {
        const parts = slug.split('-');
        if (parts.length !== 3) throw new Error('Invalid slug format');

        return parts.map(part => {
            let num = 0;
            for (const char of part) {
                const index = BASE62.indexOf(char);
                if (index === -1) throw new Error('Invalid slug character');
                num = num * 62 + index;
            }
            return num.toString(16).padStart(8, '0');
        }).join('');
    }

    // Fallback to old single-part format
    let num = 0;
    for (const char of slug) {
        const index = BASE62.indexOf(char);
        if (index === -1) throw new Error('Invalid slug character');
        num = num * 62 + index;
    }
    return num.toString(16).padStart(24, '0');
};
